export default __webpack_public_path__ + "static/media/Database class diagram gestion de pharmacie.34e5c4b5.webp";